var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShippedBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_987_2449)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_987_2449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.25 24.4995H14C13.2044 24.4995 12.4413 24.1834 11.8787 23.6208C11.3161 23.0582 11 22.2952 11 21.4995V15.4995C11 14.5049 11.3951 13.5511 12.0983 12.8479C12.8016 12.1446 13.7554 11.7495 14.75 11.7495H18.5C18.9925 11.7495 19.4801 11.8465 19.9351 12.035C20.39 12.2234 20.8034 12.4996 21.1517 12.8479C21.4999 13.1961 21.7761 13.6095 21.9645 14.0644C22.153 14.5194 22.25 15.0071 22.25 15.4995V24.4995ZM29 19.2495V18.4995C29 18.0071 28.903 17.5194 28.7145 17.0644C28.5261 16.6095 28.2499 16.1961 27.9016 15.8479C27.5534 15.4996 27.14 15.2234 26.6851 15.035C26.2301 14.8465 25.7425 14.7495 25.25 14.7495H23.75V19.2495H29ZM23.75 20.7495V24.4995H26C26.7956 24.4995 27.5587 24.1834 28.1213 23.6208C28.6839 23.0582 29 22.2952 29 21.4995V20.7495H23.75ZM14.0435 25.9995C14.016 26.1227 14.0014 26.2483 14 26.3745C14 26.8718 14.1975 27.3487 14.5492 27.7003C14.9008 28.052 15.3777 28.2495 15.875 28.2495C16.3723 28.2495 16.8492 28.052 17.2008 27.7003C17.5525 27.3487 17.75 26.8718 17.75 26.3745C17.7486 26.2483 17.734 26.1227 17.7065 25.9995H14.0435ZM22.2935 25.9995C22.266 26.1227 22.2514 26.2483 22.25 26.3745C22.25 26.8718 22.4475 27.3487 22.7992 27.7003C23.1508 28.052 23.6277 28.2495 24.125 28.2495C24.6223 28.2495 25.0992 28.052 25.4508 27.7003C25.8025 27.3487 26 26.8718 26 26.3745C25.9986 26.2483 25.984 26.1227 25.9565 25.9995H22.2935Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_987_2449",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3250FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BB2FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_987_2449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippedBanner);
export default __webpack_public_path__ + "static/media/shipped_banner.38b42448a5e5ba8b14092de9aea34905.svg";
export { ForwardRef as ReactComponent };